import { Injectable } from '@angular/core';
import { AbstractToolService } from './abstract-tool.service';
import { DesignHostContainer } from '../types';

@Injectable({
  providedIn: 'root'
})
export class MoveUpToolService extends AbstractToolService {
  constructor() {
    super();
  }

  do(host: DesignHostContainer, args: any) {
    host.parentHost.moveUpView(host.componentRef.hostView);
    // host.parentHost.move(host.componentRef.hostView, index - 1);

    super.raiseCompletedEvent(args);
  }
}
